import { useTranslation } from 'react-i18next';

import success from '../../assets/images/backoffice/kyc6.png';
import { H3 } from '../../styles/FontStyles';
import { Button, Flexed } from '../../styles/GlobalComponents';
import { color } from '../../styles/GlobalStyles';

export const Success = ({
  setIsSideModalOpen
}: {
  setIsSideModalOpen: any;
}) => {
  const { t } = useTranslation('marketplace');

  return (
    <>
      <Flexed justifyCenter>
        <img src={success} alt='success' />
      </Flexed>
      <H3 center mb='5' color={color.colors.neutral900}>
        {t('order_successfully_purchased')}
      </H3>

      <Flexed justifyCenter mt='40'>
        <Button onClick={() => setIsSideModalOpen(false)}>
          {t('close_button')}
        </Button>
      </Flexed>
    </>
  );
};
